// extracted by extract-css-chunks-webpack-plugin
module.exports = {"carousel":"_3uzkbI","slickContainer":"_3m996n","carouselContainer":"_1MO2Wh","lastSlide":"_1PDVRs","carouselCard":"QJ8dox"};